const urlRegex = /(https?:\/\/[^\s]+)/g;

// accepts text/string and returns last url and checks whether its of YouTube or Facebook Watch otherwise null
export const getLinkDataFromText = (text) => {
  if (!text) return null;

  const urls = text.match(urlRegex);

  if (urls?.length > 0) {
    const lastUrl = urls[urls.length - 1];
    const hostname = new URL(lastUrl).hostname;
    const linkData = {
      sitename: "",
      url: lastUrl,
    };

    if (
      hostname.toLowerCase() === "youtube" ||
      hostname.toLowerCase() === "youtu.be"
    ) {
      linkData.sitename = "youtube";

      return linkData;
    } else if (hostname.toLowerCase() === "fb.watch") {
      linkData.sitename = "facebook watch";

      return linkData;
    }
  }

  return null;
};
